import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { canAccessRoute, getDefaultRoute } from "@/lib/rbac";

/**
 * Blocks a route when the user lacks access and redirects to their default landing page.
 *
 * @param {string} path  - Route path (e.g. "/", "/patients")
 * @param {React.ReactNode} children
 */
export default function PermissionRoute({ path, children }) {
  const { user, permissions, isLoading } = useAuth();
  const location = useLocation();
  const role = user?.role;
  const rbacOptions = { individualDoctor: Boolean(user?.individual_doctor) };

  if (isLoading) return null;

  const requestedPath = location.pathname || path;
  if (!canAccessRoute(permissions, requestedPath, role, rbacOptions)) {
    const target = getDefaultRoute(permissions, role);
    // Safety net — never redirect to the same blocked path
    const safeTarget = target === path || requestedPath === target ? "/sharing" : target;
    return <Navigate to={safeTarget} replace />;
  }

  return children;
}
